import { DateRangeFormat } from '@intentsify/types';
import { DateFormat, formatDate } from './dates';
import { formatDateRange } from './formatDateRange';
const getDate = (dates) => {
    if (!dates) {
        return formatDate({ format: DateFormat.DateMonthDash });
    }
    const { start, end } = dates;
    if (start && end) {
        return formatDateRange({ start, end }, DateRangeFormat.StartEndDateMonthDash);
    }
    if (start) {
        return formatDate({
            date: new Date(start),
            format: DateFormat.DateMonthDash,
        });
    }
    return formatDate({ format: DateFormat.DateMonthDash });
};
export const getExportFileName = ({ prefix, data, dates, extension = '.csv', }) => {
    return `${prefix}${!data?.id ? '' : `_${data.id}`}_${getDate(dates)}${extension ? extension : ''}`;
};
//# sourceMappingURL=getExportFileName.js.map